import { render, staticRenderFns } from "./RequestsModeration.vue?vue&type=template&id=3f6df8a0&"
import script from "./RequestsModeration.vue?vue&type=script&lang=js&"
export * from "./RequestsModeration.vue?vue&type=script&lang=js&"
import style0 from "./RequestsModeration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports